<template>
    <llp-page
    id="datatable-page"
    :menuOptions="menuOptions"
     :pageName="pageName"
      :userName="userName"
  >
   <template v-slot:body>
    <div class="thank-page">
        <h4>
            Thank you,your payment has been success.
        </h4>
       
      <llp-button
        :load-spinner="showaddadminSpinner"
        classNames="btn-secondary new-btn"
         @click="BackToBBPSServices()"
      >
        Back To Services
      </llp-button>
   
    </div>
   </template>
    </llp-page>
  <llp-toast ref="toast"></llp-toast>

</template>

<script>


export default{
    setup() {

     },
     data()
     {
       
     },
     methods:{
        BackToBBPSServices() {
      this.$router.push("/services");
    },
     }
}
</script>
<style scoped>

</style>
